<template>
  <div class="login-container">
    <span class="title">We have a plan for everyone</span>
    <div class="login-content">
      <div class="plans">
        <div class="plan-card lite">
          <div class="card-title">
            <div class="name">
              <span class="name-text">Smart Bio</span>
            </div>
            <div class="price">
              <span class="price-amount">${{ litePlanPrice }}</span>
              <span>/</span>
              <span class="price-unit">{{ interval }} per artist</span>
            </div>
          </div>
          <div class="card-content">
            <div class="list">
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Artist Bio Page</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Smart Deeplinks<br />Open apps and autoplay</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Meta Pixel and FB Conversions API</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>TikTok Pixel and Event API</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>UTM Tracking</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Team Management</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Custom Domains</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Lifetime Statistics</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button
              @click="selectPlan('bio')"
              class="button-secondary big plausible-event-name=Plan+Chosen"
              :disabled="loading === 'bio'"
            >
              <span v-if="loading === 'bio'">Submitting....</span>
              <span v-else>Start free trial</span>
            </button>
          </div>
        </div>
        <div class="plan-card pro">
          <div class="card-title">
            <div class="name">
              <span class="name-text">Pro</span>
              <span class="badge-default">Most Popular</span>
            </div>
            <div class="price">
              <span class="price-amount">${{ proPlanPrice }}</span>
              <span>/</span>
              <span class="price-unit">{{ interval }} per artist</span>
            </div>
          </div>
          <div class="card-content">
            <div class="list">
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Everything in Smart Bio</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Song Landing Pages</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Album Landing Pages</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Playlist Landing Pages</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Pre-release Pages</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Future Presave Subscriptions</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>New Music Alerts</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Email List Building</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button
              @click="selectPlan('pro')"
              class="button-default big plausible-event-name=Plan+Chosen"
              :disabled="loading === 'pro'"
            >
              <span v-if="loading === 'pro'">Submitting....</span>
              <span v-else>Start free trial</span>
            </button>
          </div>
        </div>
        <div class="plan-card max">
          <div class="card-title">
            <div class="name">
              <span class="name-text">Max</span>
            </div>
            <div class="price">
              <span class="price-amount">${{ maxPlanPrice }}</span>
              <span>/</span>
              <span class="price-unit"
                >{{ interval }} per artist + SMS Pricing</span
              >
            </div>
          </div>
          <div class="flex-1 card-content">
            <div class="list">
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Everything in Pro</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>1-Click Presave Pro</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Release Day Emails</span>
              </div>
              <div class="list-item active">
                <div class="item-icon">
                  <CheckIcon class="icon small" />
                </div>
                <span>Auto-follow on Spotify</span>
              </div>
            </div>
          </div>
          <div class=" card-footer">
            <button
              @click="selectPlan('max')"
              class="button-secondary big plausible-event-name=Plan+Chosen"
              :disabled="loading === 'max'"
            >
              <span v-if="loading === 'max'">Submitting....</span>
              <span v-else>Start free trial</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="false && !discountApplied" class="coupon-card input">
        <span class="card-description">
          Do you have a coupon code?
        </span>
        <div class="floating-label coupon-input">
          <input
            v-model="discount"
            placeholder="Enter code"
            type="text"
            name="coupon"
            id="coupon"
            autocomplete="off"
          />
          <label for="coupon">Coupon code</label>
        </div>
        <button
          @click="applyDiscount()"
          :disabled="!discount"
          class="button-default big"
        >
          <span>Apply</span>
        </button>
      </div>
      <div v-if="discountApplied" class="coupon-card remove">
        <span class="card-description">
          Your discount is applied.
        </span>
        <div class="coupon-result">
          <img :src="'/img/Signup-DiscountSmiley.png'" />
          <span class="coupon-result">{{ couponText }}</span>
        </div>
        <button @click="removeDiscount()" class="button-secondary big">
          <span>Remove Discount</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import CheckIcon from "../../../public/img/icons/check.svg";
// import CloseIcon from "../../../public/img/icons/close.svg";
import { mapState } from "vuex";
import {
  Q_PRO_PRICING,
  Q_CHECK_DISCOUNT_COUPON,
  M_ADD_INITIAL_ARTISTS,
} from "@/graphql";
export default {
  name: "AddArtistWizardStepSelectPlan",
  components: {
    CheckIcon,
    // CloseIcon
  },
  data() {
    return {
      discount: null,
      discountApplied: false,
      discountName: null,
      proPricing: null,
      loading: null,
    };
  },
  async created() {
    if (this.coupon) {
      this.discount = this.coupon;
      await this.applyDiscount();
    }
  },
  apollo: {
    proPricing: {
      query: Q_PRO_PRICING,
      variables() {
        return {
          user_id: this.user.id,
        };
      },
      skip() {
        return !this.user;
      },
      update(data) {
        return data.users_by_pk.pro_pricing;
      },
    },
  },
  computed: {
    ...mapState("addArtist", ["coupon", "artists", "selected_plan"]),
    user() {
      return this.$store.getters.getUser;
    },
    yearly() {
      return this.user.billing_interval === "yearly";
    },
    litePlanPrice() {
      return this.yearly ? 90 : 9;
    },
    proPlanPrice() {
      return this.proPricing;
    },
    maxPlanPrice() {
      return this.yearly ? 290 : 29;
    },
    interval() {
      return this.yearly ? "yr" : "mo";
    },
    couponText() {
      return "Done";
    },
    isTrial() {
      return (
        (this.user.braintree_subscription_status == "Trial" ||
          !this.user.braintree_subscription_status) &&
        this.user.plan != "family"
      );
    },
  },
  methods: {
    async next() {
      if (this.isTrial) {
        await this.addTrialArtist();
      } else {
        this.$emit("nextStep");
      }
    },
    async addTrialArtist() {
      try {
        this.loading = this.selected_plan;
        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_ADD_INITIAL_ARTISTS,
          variables: {
            artists: this.artists.map((x) => ({
              id: x.spotify_id,
              name: x.name,
              image: x.avatar_url,
              selected_plan: this.selected_plan,
            })),
            email: this.user.email,
            coupon: this.discount,
          },
        });

        console.log(response);
        const { user, token } = response.data.braintree_add_initial_artists;
        if (token) {
          localStorage.setItem("token", token);
          await this.$store.dispatch("setUser", user);
          await this.$store.dispatch("setArtist", user.artists[0]);
          this.$store.commit("signup/setArtists", user.artists);
          this.$emit("setStep", 5);
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Something went wrong. Please try again.`,
          });
        }
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${err.message.replace("GraphQL error: ", "")}`,
        });
      } finally {
        this.loading = null;
      }
    },
    selectPlan(plan) {
      if (this.discountApplied)
        this.$store.commit("addArtist/setCoupon", this.discount);
      this.$store.commit("addArtist/setSelectedPlan", plan);
      this.next();
    },
    async applyDiscount() {
      try {
        const result = await this.$apollo.query({
          client: "localClient",
          query: Q_CHECK_DISCOUNT_COUPON,
          variables: {
            coupon: this.discount,
          },
        });

        if (!result.data.check_discount_coupon.success) {
          throw new Error("Invalid coupon");
        }

        this.discountName = result.data.check_discount_coupon.coupon.name;
        this.discountApplied = true;
      } catch (e) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Invalid coupon",
        });
      }
    },
    removeDiscount() {
      this.$store.commit("addArtist/setCoupon", null);
      this.discount = null;
      this.discountName = null;
      this.discountApplied = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  /* BG/type2 */
  //background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo-icon {
    width: 54px;
  }

  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }

  .login-content {
    //width: 630px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    margin-top: 30px;

    .plans {
      margin-top: 30px;
      //display: grid;
      //grid-template-columns: repeat(auto-fit, 300px);
      //grid-gap: 30px;
      display: grid;
      grid-gap: 24px 30px;
      grid-template-columns: 1fr 1fr 1fr;

      //grid-template-columns: repeat(auto-fill, minmax(300px, auto));
      //.create-link-box {
      //  width: 100%;
      //}
      //display: flex;
      .plan-card {
        width: 300px;
        //width: 100%;
        padding: 12px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;

        .card-title {
          padding: 12px;
          border-bottom: 1px solid $bg-type-1;

          .name {
            display: flex;

            .name-text {
              flex: 1;
              /* 18/Bold */
              font-weight: bold;
              font-size: 18px;
              line-height: 30px;
              /* White */
              color: white;
              mix-blend-mode: normal;
              opacity: 0.9;
            }
          }

          .price {
            margin-top: 12px;
            color: $text-type-0;
            font-size: 30px;
            line-height: 44px;

            //display: grid;
            span {
              margin-right: 6px;
            }

            .price-amount {
              font-weight: bold;
              color: white;
            }

            .price-unit {
              font-size: 18px;
              //line-height: 22px;
            }
          }
        }

        .card-content {
          //padding: 0 12px;
          padding: 12px;
          //display: flex;
          //flex-direction: column;
          //align-items: center;
          flex: 1;

          .list {
            display: grid;
            grid-gap: 18px;

            .list-item {
              display: flex;
              align-items: center;
              /* 12/SemiBold */
              font-weight: 600;
              font-size: 12px;
              line-height: 15px;
              /* White */
              color: #ffffff;

              &.active {
                .item-icon {
                  svg {
                    path {
                      fill: white;
                    }
                  }
                }

                span {
                  color: white;
                }
              }

              &.disabled {
                .item-icon {
                  svg {
                    path {
                      fill: #ccc;
                    }
                  }
                }

                span {
                  color: #ccc;
                }
              }

              .item-icon {
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;

                svg {
                  path {
                    fill: $text-type-2;
                  }
                }
              }

              span {
                margin-left: 6px;
                color: $text-type-2;
              }
            }
          }
        }

        .card-footer {
          padding: 12px;
          display: flex;
          justify-content: center;
          /* button {
            width: 176px;
          } */
        }

        &.lite,
        &.max {
          background: linear-gradient(
            241.25deg,
            rgba(41, 39, 85, 0.45) 4.4%,
            rgba(41, 39, 84, 0.85) 61.77%,
            rgba(27, 24, 66, 0.45) 119.94%
          );
          box-shadow: 0 51px 69px rgba(23, 18, 43, 0.585739);
          backdrop-filter: blur(23px);
          /* Note: backdrop-filter has minimal browser support */
        }

        &.pro {
          //margin-left: 30px;
          background: #100e2a;
        }
      }
    }

    .coupon-card {
      margin-top: 30px;
      width: 100%;
      padding: 24px;
      display: grid;
      grid-template-columns: 1fr auto;
      grid-gap: 16px 24px;
      /* BG/type2 */
      background: $bg-type-2;
      /* Purple-stroke */
      border: 1px solid $purple-stroke;
      box-sizing: border-box;
      border-radius: 10px;

      &.input {
        grid-template-areas:
          "description description"
          "input apply";

        .coupon-input {
          grid-area: input;
        }

        button {
          grid-area: apply;
          width: 108px;
        }
      }

      &.remove {
        grid-template-areas:
          "description description"
          "result remove";

        .coupon-result {
          grid-area: result;
          display: flex;
          align-items: center;
          gap: 13px;

          img {
            width: 35px;
          }

          span {
            /* 24/Bold */
            font-weight: bold;
            font-size: 24px;
            line-height: 42px;
            display: flex;
            align-items: center;
            color: #fffafa;
          }
        }

        button {
          grid-area: remove;
          width: 183px;
        }
      }

      .card-description {
        grid-area: description;
        /* 18/SemiBold */
        font-weight: 600;
        font-size: 18px;
        line-height: 30px;
        /* White */
        color: white;
        mix-blend-mode: normal;
        opacity: 0.9;
      }
    }
  }
}
</style>
